import { render, staticRenderFns } from "./taskTypeContactDefaultStock.vue?vue&type=template&id=087662c4&"
import script from "./taskTypeContactDefaultStock.vue?vue&type=script&lang=js&"
export * from "./taskTypeContactDefaultStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports